import React, { useState } from 'react';
import './ContactUs.css';
import {
    FaMapMarkerAlt,
    FaBuilding,
    FaLink,
    FaEnvelope,
    FaPhone,
    FaPaperPlane,
} from 'react-icons/fa';
import { FiCheckCircle } from 'react-icons/fi';
const API_BASE = process.env.REACT_APP_API_BASE || 'http://localhost:5000';

const ContactPage = () => {
    const [isSubmitted, setIsSubmitted] = useState(false);

    // ✅ FormSubmit ke through email bhejna
    const handleFormSubmit = async (e) => {
        e.preventDefault();

        const form = e.target;
        const data = {
            Name: form.Name.value,
            Email: form.Email.value,
            Phone: form.Phone.value,
            Company: form.Company.value,
            Country: form.Country.value,
            Message: form.Message.value,
        };

        try {
            const response = await fetch(`${API_BASE}/api/contact`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data),
            });

            if (!response.ok) {
                throw new Error('Failed to send message');
            }

            setIsSubmitted(true);
            form.reset();
            setTimeout(() => setIsSubmitted(false), 4000);
        } catch (err) {
            console.error('Form submit error:', err);
            alert('Unable to send message at this time. Please try again later.');
        }
    };

    return (
        <div className="contact-container">
            <div className="products-heading">
                <h1>Contact Karim Industries</h1>
                <p>Get in touch with Pakistan's leading surgical dressing manufacturer</p>
            </div>

            <div className="contact-content">
                {/* Contact Info */}
                <div className="contact-info">
                    <div className="info-section">
                        <h2><FaMapMarkerAlt className="icon" /> Factory Address</h2>
                        <p>½ Km Raiwind Road, Raiwind<br />Lahore-Pakistan</p>
                        <p><FaPhone className="icon" /> +92-42-35392174</p>
                    </div>
                    <div className="info-section">
                        <h2><FaBuilding className="icon" /> Head Office</h2>
                        <p>135-C Nawab Town, Thokar Niaz Baig<br />Lahore-Pakistan</p>
                        <p><FaPhone className="icon" /> +92-42-35233001</p>
                        <p><FaPhone className="icon" /> +92-300-4090248</p>
                    </div>
                    <div className="info-section">
                        <h2><FaLink className="icon" /> Online Contacts</h2>
                        <p><FaEnvelope className="icon" /> info@karimindustries.com.pk</p>
                        <p><FaEnvelope className="icon" /> karim.industries786@gmail.com</p>
                    </div>
                    {/* <div className="info-section">
                        <h2><FaUserTie className="icon" /> Liason Office</h2>
                        <p>Ch. Imam Din Medicine Market, 2nd Floor, Room No. 12<br />
                            outside Lohari Gate Lahore-Pakistan</p>
                        <p><FaPhone className="icon" /> +92-42-37249148</p>
                    </div> */}
                </div>

                {/* Contact Form */}
                <div className="contact-form">
                    <h2>Send Us a Message</h2>
                    {isSubmitted ? (
                        <div className="success-message">
                            <FiCheckCircle className="success-icon" />
                            <h3>Thank You!</h3>
                            <p>Your message has been sent successfully. We'll contact you soon.</p>
                        </div>
                    ) : (
                        <form
                            action={`${API_BASE}/api/contact`}
                            method="POST"
                            onSubmit={handleFormSubmit}
                        >

                            <div className="form-group">
                                <label htmlFor="Name">Name*</label>
                                <input type="text" id="Name" name="Name" required />
                            </div>

                            <div className="form-group">
                                <label htmlFor="Country">Select Your Country*</label>
                                <select id="Country" name="Country" required>
                                    <option value="">Select Country</option>
                                    <option value="Pakistan">Pakistan</option>
                                    <option value="India">India</option>
                                    <option value="USA">USA</option>
                                    <option value="UK">UK</option>
                                    <option value="UAE">UAE</option>
                                    <option value="Other">Other</option>
                                </select>
                            </div>

                            <div className="form-group">
                                <label htmlFor="Company">Name of Company/Hospital/other*</label>
                                <input type="text" id="Company" name="Company" required />
                            </div>

                            <div className="form-group">
                                <label htmlFor="Phone">Phone/Contact no*</label>
                                <input type="tel" id="Phone" name="Phone" required />
                            </div>

                            <div className="form-group">
                                <label htmlFor="Email">Email*</label>
                                <input type="Email" id="Email" name="Email" required />
                            </div>

                            <div className="form-group">
                                <label htmlFor="Message">Message</label>
                                <textarea id="Message" name="Message" rows="5"></textarea>
                            </div>

                            <button type="Submit" className="submit-btn">
                                <FaPaperPlane className="Submit-icon" /> Send
                            </button>
                        </form>
                    )}
                </div>
            </div>

            {/* Factory Location */}
            <div className="locations-container">
                <div className="map-box">
                    <h2 className="text-lg font-semibold mb-2">Factory Location</h2>
                        <iframe
                            src="https://www.google.com/maps?q=31.2906556,74.2248142&z=15&output=embed"
                            width="100%"
                            height="350"
                            style={{ border: 0 }}
                            allowFullScreen=""
                            loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade"
                            title="Factory Location"
                        ></iframe>
                </div>
            </div>

            {/* Office Location */}
            <div className="map-box">
                <h2 className="text-lg font-semibold mb-2">Office Location</h2>
                <iframe
                    src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3403.439984903642!2d74.2440916965424!3d31.457080788792!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3919018bec51fab1%3A0x57d73c073b240d3d!2s135%2FC%20Nawab%20Town%20Rd%2C%20Block%20C%20Nawab%20Town%2C%20Lahore%2C%2054000!5e0!3m2!1sen!2s!4v1756373496098!5m2!1sen!2s"
                    width="100%"
                    height="350"
                    style={{ border: 0 }}
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    title="Office Location"
                ></iframe>
            </div>
        </div>
    );
};

export default ContactPage;
